import { useNavigate } from "react-router-dom"
import { Navbar } from "../../components/Navbar/Navbar"
import Providences from "../../components/Providences"
import { useEffect, useRef, useState } from "react"
import { validateToken } from "../../services/AuthService"
import { SessionExpiredCard } from "../../components/SessionExpiredCard"

const DashboardProvidence = () => {
    const token = localStorage.getItem("site")
    const navigate = useNavigate()
    const timeoutRef = useRef()
    const [isValidate, setIsValidate] = useState(false)

    useEffect(()=> {
        validateToken(token)
            .then((response) => {
                if (response.status === 200) setIsValidate(true)
            })
            .catch((err)=>{
                if (err.response.status) {
                    setIsValidate(false)
                    timeoutRef.current = setTimeout(() => {
                        navigate("/login")
                    },4000)
                }
            })
    },[])

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (
        <>
            {isValidate && (
                <>
                    <Navbar />
                    <Providences />
                </>
            )}
            {!isValidate && (
                <SessionExpiredCard />
            )}
        </>
    )
}

export default DashboardProvidence